var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrigami(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.12 42.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daf0f2;}.cls-2{fill:#263980;}.cls-3{fill:#e5ab30;}.cls-4{fill:#c72318;}.cls-5{fill:#f8e93c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.84 1.69 13.25 1.69 1.95 21.26 13.25 40.82 35.84 40.82 47.14 21.26 35.84 1.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.85,42.51H12.27L0,21.26,12.27,0H36.85L49.12,21.26Zm-22.6-3.38h20.6L45.17,21.26,34.85,3.38H14.22L3.91,21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.41,27.24l-3.81-4L15,21.54a.47.47,0,0,1,.35-.26l9.13-2.63.81-.25c.29-.09.31-.16.09-.38l-2.49-2.5c-.13-.13-.35-.22-.31-.47.36-.67.61-1.38.91-2.07.75-1.74,1.48-3.48,2.22-5.23,0-.08.07-.15.13-.28l1,2.41L29,15.08a.88.88,0,0,0,.07.23.61.61,0,0,1-.18.4c-.8.81-1.59,1.61-2.4,2.4a1.31,1.31,0,0,0-.3.41A3.73,3.73,0,0,0,26,19.57c-.14,1.67-.3,3.34-.45,5-.13,1.44-.26,2.88-.4,4.31C25.1,29.6,25,30.31,25,31a2.16,2.16,0,0,1-.21.71H24.7a.74.74,0,0,1-.51-.35c-.46-.57-1-1.06-1.51-1.6-.66-.7-1.29-1.41-2-2.07A.63.63,0,0,1,20.41,27.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.59,15l3.14,3.11c.21.21.05.27-.13.32l-3.2.92L15,21.53V7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.72,31.7c.07-.76.13-1.52.2-2.29s.15-1.54.22-2.32c.1-1,.19-2.08.29-3.13.06-.76.13-1.53.2-2.29.09-1.07.2-2.15.3-3.22l.06-.14a.54.54,0,0,1,.32.21q2.69,2.7,5.38,5.38a1.38,1.38,0,0,1,.3.49c0,.1-.07.13-.12.19l-7,7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32,24.39l-.31-.29-5.43-5.43c-.1-.11-.23-.2-.26-.36l2.73-2.75.26-.3a9.14,9.14,0,0,0,.9-.86l2.07-2c.21,0,.19.23.19.39v3.94a.55.55,0,0,1-.14.47v6.86C32,24.14,32,24.27,32,24.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.41,27.24c.45.56,1,1,1.48,1.56.64.73,1.34,1.4,2,2.1.26.27.5.55.75.83l-3.48,1.15L14.79,35a.23.23,0,0,1-.2,0l.2-.28q2.73-3.66,5.48-7.31C20.32,27.4,20.36,27.32,20.41,27.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32,17.16V12.77a.72.72,0,0,0,0-.41c.08-.12.17,0,.23,0l3,1.26a.52.52,0,0,1,.34.38c.45,1.36.9,2.71,1.37,4.09Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigami);
export default __webpack_public_path__ + "static/media/origami.1c062b57966e9e785f37537e76b332bb.svg";
export { ForwardRef as ReactComponent };